import React, { useCallback, useState } from 'react';

export type TAnchor = null | Element | (() => Element);
export type TToggleAnchor = (event?: React.MouseEvent<TAnchor>) => void;

export const useAnchor = (): [TAnchor, TToggleAnchor] => {
  const [anchorEl, setAnchorEl] = useState<TAnchor>(null);

  const toggleAnchor = useCallback((event?: React.MouseEvent<TAnchor>) => {
    setAnchorEl(event ? event.currentTarget : null);
  }, []);

  return [anchorEl, toggleAnchor];
};
